@if ((ownerList$ | async)?.length && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
  @if (owner$ | async; as owner) {
    @if (!isTheOwner && (hasOwnerWritePermission$ | async)) {
      <button
        mat-stroked-button
        (click)="switchToOwner()"
        [matTooltip]="
          'owner_chip.switch.tooltip'
            | translate
              : {
                  organizationUnitType: owner.organization_unit_type_id | ou_type_name | translate
                }
        "
        class="status-chip customer-chip owner-chip"
        [ngClass]="owner.roleStyleClass"
      >
        <span class="owner-chip-content">
          <mat-icon>{{ owner.roleIcon }}</mat-icon>
          <span class="owner-chip-name">{{ owner.name }}</span>
          @if (owner.roleDisplayName) {
            <span class="owner-chip-role">({{ owner.roleDisplayName }})</span>
          }
          @if ((extraOwners$ | async)?.length) {
            <span
              class="owner-chip-extra"
              [matMenuTriggerFor]="ownerChipMenu"
              (click)="$event.stopPropagation()"
            >
              +{{ (extraOwners$ | async)?.length }}
            </span>
          }
        </span>
      </button>
    }
    @if (isTheOwner || !(hasOwnerWritePermission$ | async)) {
      <mat-chip class="status-chip customer-chip owner-chip" [ngClass]="owner.roleStyleClass">
        <span class="owner-chip-content">
          <mat-icon>{{ owner.roleIcon }}</mat-icon>
          <span class="owner-chip-name">{{ owner.name }}</span>
          @if (owner.roleDisplayName) {
            <span class="owner-chip-role">({{ owner.roleDisplayName }})</span>
          }
          @if ((extraOwners$ | async)?.length) {
            <span class="owner-chip-extra" [matMenuTriggerFor]="ownerChipMenu">
              +{{ (extraOwners$ | async)?.length }}
            </span>
          }
        </span>
      </mat-chip>
    }

    <mat-menu #ownerChipMenu="matMenu" class="owner-chip-menu">
      <div class="owner-chip-menu-content" (click)="$event.stopPropagation()">
        <div class="owner-chip-menu-title">{{ 'owner_chip.also_owned_by' | translate }}</div>
        @for (organizationUnit of ownerList$ | async; track organizationUnit.id) {
          <button
            type="button"
            mat-menu-item
            class="owner-chip-menu-row"
            [ngClass]="organizationUnit.roleStyleClass"
            (click)="switchToOrganizationUnit(organizationUnit)"
          >
            <span class="owner-chip-menu-row-content">
              <span class="owner-chip-menu-name">
                <mat-icon>{{ organizationUnit.roleIcon }}</mat-icon>
                <span>{{ organizationUnit.name }}</span>
              </span>
              @if (organizationUnit.roleDisplayName) {
                <span class="owner-chip-menu-role">{{ organizationUnit.roleDisplayName }}</span>
              }
            </span>
          </button>
        }
      </div>
    </mat-menu>
  }
}
